export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const pad = (n: number): string => String(n).padStart(2, '0');

export const toISODate = (d: Date): string => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export function fromISODate(s: string | null | undefined): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s ?? '');
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
}
export const addDays = (d: Date, n: number): Date => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
export const startOfDay = (d = new Date()): Date => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const sameDay = (a: Date, b: Date): boolean => a.getTime() === b.getTime();

/** "Today", "Tomorrow", "Yesterday", or "6 Nov" / "6 Nov 2027" (en-GB, PLAN default date format). */
export function formatDay(d: Date, today = startOfDay()): string {
  const diff = Math.round((d.getTime() - today.getTime()) / 864e5);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: d.getFullYear() === today.getFullYear() ? undefined : 'numeric' });
}

/** 42 cells (6 weeks, Monday first) for a month grid. */
export function monthGrid(view: Date): Date[] {
  const first = new Date(view.getFullYear(), view.getMonth(), 1);
  const start = addDays(first, -((first.getDay() + 6) % 7));
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
}

export type TMinusTone = 'ok' | 'soon' | 'today' | 'late' | 'done';
/** Mission-theme due chip: T-2d / T-0 Today / +3d late / Done. */
export function tMinus(due: Date, { done = false, today = startOfDay() } = {}): { label: string; tone: TMinusTone } {
  if (done) return { label: 'Done', tone: 'done' };
  const diff = Math.round((startOfDay(due).getTime() - today.getTime()) / 864e5);
  if (diff < 0) return { label: `+${-diff}d late`, tone: 'late' };
  if (diff === 0) return { label: 'T-0 Today', tone: 'today' };
  return { label: `T-${diff}d`, tone: diff <= 2 ? 'soon' : 'ok' };
}
